<template>
  <div class="top">
    <div class="card1">
      <p class="name">
        <span class="active">卡总数</span>
      </p>
      <div class="card1__info">
        <div>
           <!-- <el-tooltip class="item" effect="dark" :content="'正常：'+card1Data.normal" placement="right"> -->
             <div class="water"  @click.stop="goClick('all','')">
               <lazyRender :time="1000">
              <water-echart :data="card1Data.totalNum/(card1Data.totalNum+1000)" :flag="2"/>
              </lazyRender>
               <div class="num">
            <p style="color: #fff">{{card1Data.totalNum}}</p>
          </div>
          </div>
          <!-- </el-tooltip>
           <el-tooltip class="item" effect="dark" :content="'正常：'+card1Data.normal" placement="right"> -->
             <div class="water"  @click.stop="goClick('normal',4)" :flag="1">
               <lazyRender :time="1000">
              <water-echart :data="card1Data.normal/card1Data.totalNum"/>
              </lazyRender>
               <div class="num">
            <p >{{card1Data.normal}}</p>
          </div>
          </div>
          <!-- </el-tooltip>        -->
        </div>
        <div class="card1__list">
          <div v-for="(item, index) in list" :key="index" @click.stop="goClick(item.key,item.status)">
            <img :src="item.icon" />
            <div>
              {{ item.name }}
              <span>{{ card1Data[item.key] || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2" ref="refCard2">
      <p class="name name__tabs">
        <span 
          v-for="(item,index) in centerTabs" 
          :key="index" 
          @click="onClickTab(index)" 
          :class="`${centerType === index ? 'active' : ''}`"
        >{{ item }}</span>
      </p>
      <div v-if="!centerType" class="card2__table">
        <div class="card2__header">
          <span>卡号</span>
          <span>总流量</span>
          <span>使用流量</span>
        </div>
        <div class="card2__body">
          <p v-for="(item,index) in card2Data" :key="index">
            <span>{{item.simCard}}</span>
            <!-- >= 1024?item.traffic/1024+'MB':item.traffic+'KB' -->
            <span>{{formatterGprs(item.traffic)}}</span> 
            <span>
              <span :class="{'traffic':item.traffic < item.useTraffic}">{{formatterGprs(item.useTraffic)}}</span>
              <!-- <el-progressF
                :stroke-width="15"
                :percentage="100-((item.useTraffic / item.traffic)*100)"
              
                :show-text="false"
                :color="'linear-gradient(#334df6 0%, #14f524 100%);'"
              ></el-progress>             -->
            </span>
             
          </p>
        </div>
      </div>
      <FlowPool v-else :height="card2Height" />
    </div>
    <div class="card3" @click="goClick('virtualCurrency')">
      <p class="name">
        <span class="active">虚拟币</span>
      </p>
      <img src="@/assets/images/home/home1.png" />
      <div class="card3__content">
        <div>
          <span>
            虚拟币数量:
          </span>
          <span v-if="card3Data && card3Data.corn">
            <el-progress
              :stroke-width="15"
              :percentage="(card3Data.corn / card3Data.sumCorn) * 100"
              :show-text="false"
              :color="'linear-gradient(#334df6 0%, #14f524 100%);'"
            ></el-progress>
          </span>
          <span>
           {{card3Data.corn}}
          </span>
        </div>
        <div>
          <span>
            充值总数:
          </span>
          <span>
            <el-progress
              :stroke-width="15"
              :percentage="100"
              :show-text="false"
              :color="'linear-gradient(#334df6 0%, #14f524 100%);'"
            ></el-progress>
          </span>
          <span>
            {{card3Data.sumCorn}}
          </span>
        </div>
        <div>
          <span>
            消耗总数:
          </span>
          <span v-if="card3Data && card3Data.consumeCorn">
            <el-progress
              :stroke-width="15"
              :percentage="(card3Data.consumeCorn / card3Data.sumCorn) * 100"
              :show-text="false"
              :color="'linear-gradient(#334df6 0%, #14f524 100%);'"
            ></el-progress>
          </span>
          <span>
            {{card3Data.consumeCorn}}
          </span>
        </div>
      </div>
    </div>


     <table-dialog
      @func="getMsgFormSon"
      v-show="peringatanVisible"
      :tag="flag"
      :expireSimGprsF="card1Data.expireCount"
      :expireSimCardsF="card1Data.expire"
      :predictSimGprsF="card1Data.predictCount"
      :predictSimCardsF="card1Data.predictTime"
      :peringatanVisibleF="peringatanVisible"
    >
    </table-dialog>
  </div>
</template>
<script>
import lazyRender from "@/components/lazyRender/lazyRender"
import tableDialog from "@/components/tabledialog";
import waterEchart from "@/components/waterEchart";
import FlowPool from "./flowPool.vue";
import { hasDot } from '@/util/common';
export default {
  name: "homeUp",
  components: {
    waterEchart,
    tableDialog,
    lazyRender,  //自定义的延迟加载组件
    FlowPool,
  },
  data() {
    return {
      centerType: 0,
      flag :1,
      peringatanVisible: false,
      list: [
        {
          name: "已过期",
          status:3,
          num: 130,
          key:'parking',
          icon: require("@/assets/images/home/1.png"),
        },
        {
          name: "未激活",
          status:1,
          num: 130,
          key:'inactive',
          icon: require("@/assets/images/home/2.png"),
        },
        {
          name: "已激活",
          status:2,
          num: 130,
          key:'expire',
          icon: require("@/assets/images/home/3.png"),
        },
        {
          name: "即将到期",
          num: 130,
          key:'predictTime',
          icon: require("@/assets/images/home/6.png"),
        },
        {
          name: "超流量",
          num: 130,
          key:'expireCount',
          icon: require("@/assets/images/home/4.png"),
        },
        {
          name: "流量不足",
          num: 130,
          key:'predictCount',
          icon: require("@/assets/images/home/5.png"),
        },
        
      ],
      card1Data:{
        expire:0,   //已激活
        inactive:0,//未激活
        predictCount:0,//预超流量
        parking:0,//停机
        totalNum:0,//总数 
        predictTime:0, //预过期
        expireCount:0, //超流量
        normal:0, //正常
      }, //卡总数
      card2Data:[], //卡库存
      card3Data:{},//虚拟币统计
      
    };
  },
  computed: {
    centerTabs () {
      const tabs = ['流量消耗排行'];
      // if (this.$store.state.LOGINUSER.userCode === 'FC68'){
      //   tabs.push('流量池');
      // }
      return tabs;
    }
  },
  methods: {
    //流量转换
		formatterGprs(gprs) {
			if (!gprs) return '0kb';
			const flow = Math.abs(Number(gprs));
			const burden = Number(gprs) > 0;
			if (flow > 1024 * 1024) {
        let num = flow / (1024 * 1024);
				return `${burden ? '' : '-'}${hasDot(num,3)}G`;
			} else if (flow > 1024) {
				let num = flow / 1024;
				return `${burden ? '' : '-'}${hasDot(num,3)}M`;
			} else {
				return `${burden ? '' : '-'}${flow}kb`;
			}
		},
    // 流量消耗排行/流量池
    onClickTab (index) {
      this.centerType = index;
    },
    goClick(key,status){
      if(key === 'expireCount' || key === 'predictCount' ){
        this.flag = 1
        this.peringatanVisible = true       
      }else if( key === 'predictTime'){
        this.flag = 2
        this.peringatanVisible = true
      }else if(key === 'virtualCurrency'){
        this.$router.push('/web/virtualCurrency')
      } else{
        this.$router.push({
          name:'sim',
          params:{key:status}
        })
      }
      
       
    },
    getMsgFormSon(data) {
      this.peringatanVisible = data;
    },

    //卡总数 start
    async getVariousSimCount(){
      const { data } = await this.$API.getVariousSimCount();
      this.card1Data.totalNum = data.cardTotal;
      this.card1Data.normal = data.normal;
      this.card1Data.expire = data.activation
      this.card1Data.inactive = data.inactive
      this.card1Data.parking = data.expired
      this.card1Data.normal = data.normal
      this.card1Data.expireCount = data.exceedFlow
      this.card1Data.predictCount = data.predictExceedFlow
      this.card1Data.predictTime = data.predictExpire
    },
    //卡总数 end

    //卡库存
   async getCountFlowConsumeRank(){
     const { data } = await this.$API.countFlowConsumeRank()
     this.card2Data = data
   },
   //虚拟币统计
   async countCorn(){
    const { data } = await this.$API.countCorn()
    this.card3Data = data
   }
  },
  created () {
    this.getCountFlowConsumeRank()
    this.countCorn()
    this.getVariousSimCount()
  },
  mounted () {
    this.card2Height = this.$refs.refCard2.scrollHeight - 50;
  },
};
</script>
<style lang="scss" scoped>
@import "../../../public/css/mixin.scss";
.top {
  display: flex;
  justify-content: center;
  height: 60%;
  padding-bottom: 20px;
  color: #fff;
  .name {
    text-align: center;
    > span {
      display: inline-block;
      padding: 0 20px;
      height: 31px;
      line-height: 31px;
      opacity: 1;
      border: 1px solid #272e6d;
      font-size: 16px;
      font-family: FontName Regular, FontName Regular-Regular;
      font-weight: 400;
      color: #fefefe;
      cursor: pointer;
      &:hover{
        opacity: 0.87;
      }
    }
    .active{
      background: linear-gradient(0deg, #223085 0%, #131850 100%);
    }
  }
  .name__tabs{
    width: 60%;
    display: flex;
    margin: 0 20%;
    justify-content: center;
    >span{
      display: inline-block;
      width: 50%;
    }
  }
  > .card1 {
    width: 29%;
    height: 100%;
    overflow: auto;
    background: url("../../../assets/images/home/border1.png") no-repeat 0 0;
    background-size: 100% 100%;
    @include scrollHome;
    .card1__info {
      height: calc(100% - 40px);
      min-height: 360px;
      min-width: 360px;
      > div:nth-child(1) {
        display: flex;
        padding: 20px;
        justify-content: space-around;
        > div {
          width: 50%;
        }
        .water {
          display: flex;
          justify-content: center;
        }
        .num {
          display: flex;
          justify-content: left;
          flex-wrap: wrap;
          align-items: center;
          cursor: pointer;
          > p {
            color: #3ed84c;
            font-weight: 600;
            font-size: 20px;
            width: 100%;
          }
          > span {
            color: #fff;
            font-size: 14px;
            > span {
              color: #e1ae65;
            }
            > i {
              color: #ff4c39;
            }
          }
        }
      }
    }
    .card1__list {
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      padding: 20px;
      height: calc(100% - 200px);
      align-content:space-around;
      > div {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 10px 0;
        &:hover{
          background: rgba($color: #1da3ff, $alpha: 0.2);
          border-radius: 20px;
        }
        > img {
          width: 46px;
          height: 46px;
        }
        > div {
          text-align: center;
          padding-left: 20px;
          box-sizing: border-box;
          width: 50%;
          font-size: 14px;
          span {
            font-weight: 600;
            width: 100%;
            margin-top: 4px;
            display: block;
            color: #1da3ff;
            font-size: 26px;
          }
        }
      }
    }
  }
  > .card2 {
    width: 40%;
    height: 100%;
    margin: 0 1%;
    overflow: hidden;
    background: url("../../../assets/images/home/border2.png") no-repeat 0 0;
    background-size: 100% 100%;
    .card2__table {
      width: 100%;
      padding: 20px;
      height: calc(100% - 80px);
      box-sizing: border-box;
      min-width: 460px;
      .card2__header {
        opacity: 0.85;
        line-height: 40px;
        height: 40px;
        background: linear-gradient(to right,#181043 0%, #6f6c89 48%, #0f1138 100%);
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        text-align: center;
        > span:nth-child(1) {
          display: inline-block;
          width: 30%;
        }
        > span:nth-child(2) {
          display: inline-block;
          width: 20%;
        }
        > span:nth-child(3) {
          display: inline-block;
          width: 50%;
        }
      }
      .card2__body {
        overflow: auto;
        height: 100%;
        @include scrollHome;
        > p {
          display: flex;
          flex-wrap: nowrap;
          justify-content: center;
          margin: 4% 0;
          text-align: center;
          > span:nth-child(1) {
            display: inline-block;
            width: 30%;
            color: #a7c4e9;
          }
          > span:nth-child(2) {
            display: inline-block;
            width: 20%;
            color: #eab36a;
          }
          > span:nth-child(3) {
            display: inline-block;
            width: 50%;
            background: #151d57;
            border-radius: 10px;
            height: 16px;
          }
          ::v-deep .el-progress-bar__outer{
            background: #151D57;
            .el-progress-bar__inner {
              background: -moz-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ) !important;
              background: -webkit-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Firefox 3.6 - 15 */
              background: linear-gradient(
                to right,
                #334df6 0%,
                #14f524 100%
              ); /* 标准的语法 */
            }
          }
        }
      }
    }
  }
  > .card3 {
    width: 29%;
    height: 100%;
    overflow-y: auto;
    background: url("../../../assets/images/home/border1.png") no-repeat 0 0;
    background-size: 100% 100%;
    cursor: pointer;
    @include scrollHome;
    >img{
      width: 80%;
      margin: 20px 10%;
    }
    .card3__content{
      text-align: center;
      padding: 20px;
      box-sizing: border-box;
      >div{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-bottom: 36px;
        font-size: 14px;
        >span:nth-child(1){
          width: 20%;
          color:#A7C4E9;
        }
        >span:nth-child(2){
          margin-top: 2px;
          width: 50%;
          ::v-deep .el-progress-bar__outer{
            background: #151D57;
            .el-progress-bar__inner {
              background: -moz-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ) !important;
              background: -webkit-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(
                right,
                #334df6 0%,
                #14f524 100%
              ); /* Firefox 3.6 - 15 */
              background: linear-gradient(
                to right,
                #334df6 0%,
                #14f524 100%
              ); /* 标准的语法 */
            }
          }
        }
        >span:nth-child(3){
          width: 30%;
          color:#2AC2F7;
          font-weight: 600;
          font-size: 18px;
        }
        span{
          display: inline-block;
        }
      }
    }
  }
}
.traffic{
  color: red;
}
</style>
